import { StoreItem } from '../types/store';

// Helper: sort by current order and then renumber sequentially starting at 0
export const renumberAndSortItems = (items: StoreItem[]): StoreItem[] =>
    items
        .slice()
        .sort((a, b) => a.order - b.order)
        .map((b, idx) => ({ ...b, order: idx }));
